import { z } from "zod";
export const taskDefinitionSchema = z.object({
    /**
     * Unique task definition id, do not confuse with task id
     * can be empty for ad-hoc task definitions
     */
    id: z.string().regex(/^[a-zA-Z0-9_-]+$/, "malformed task id"),
    /**
     * Task family identifies group of identical tasks, which should be displayed in identical way, but are slightly different
     * For example, beta and production configuration of optimist have different configs, but results are in the same schema
     * this fields should be used by frontend to choose result renderer
     */
    family: z
        .string()
        .regex(/^[a-zA-Z0-9_-]+$/, "malformed task family")
        .optional(),
    /**
     * Task name for humans, used as UI tab name
     */
    name: z.string().optional(),
    /**
     * Task description, optional
     */
    description: z.string().optional(),
    /**
     * Docker image name in @gearbox-protocol org, e.g. `deploy-v3`
     */
    image: z.string().min(2),
    /**
     * Docker image version, can be prefixed with ssm:// to get version from AWS SSM, otherwise defaults to latest
     */
    version: z.string().optional(),
    /**
     * Docker entrypoint
     */
    entrypoint: z.array(z.string()).optional(),
    /**
     * Docker command
     */
    command: z.array(z.string()).optional(),
    /**
     * Environment variables to pass to container
     */
    env: z.record(z.string(), z.string()).optional(),
    /**
     * Secret to load from AWS Secrets Manager and pass as env variables to container
     * key = ENV VARIABLE NAME
     * value = (?!)AWS_SECRET_NAME.(optional json field)
     * exclamation mark means that secret should be refretched
     */
    secrets: z.record(z.string(), z.string()).optional(),
    /**
     * Will be saved as file and mounted to container
     */
    input: z.any().optional(),
    /**
     * Timeout for task in minutes
     */
    timeout: z.number().int().positive().optional(),
    /**
     * If true, task can be started concurrently with other tasks
     */
    concurrent: z.boolean().optional(),
    /**
     * Task can start other containers
     */
    multicontainer: z.boolean().optional(),
    /**
     * Schema version, to facilitate breaking changes in schema
     */
    schemaVersion: z.number().int().optional(),
});
export const taskDefinitionOverrideSchema = taskDefinitionSchema.extend({
    image: z.string().optional(),
});
